import React, {Component} from 'react';
import {LayoutSidebar} from '../../Layout';
import {ClientMemoryTabContent} from './ClientMemoryTabContent';
import {withRouterParams} from '../../utils/withRouterParams';

// Tab "Memoria del cliente". Ruta `/client/:id/memory[/:view]`. `view` selecciona la
// sub-vista (facts/documents/notes/setup); default 'facts'.
export class ClientMemoryTab extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientMemoryTabContent
                    clientId={this.props.match.params.id}
                    view={this.props.match.params.view}
                />
            </div>
        );
    }
}

export default withRouterParams(ClientMemoryTab);
